import { useMutation as e } from "@maat/store-hooks";
import { usersApi as t } from "@maat/api-main";
//#region src/users/admin/useImpersonateUserMutation.ts
var n = () => e({ mutationFn: (e) => t.impersonateUser(e) });
//#endregion
export { n as useImpersonateUserMutation };
